import { useState } from "react";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import UploadTab from "./UploadTab";
import ConvertTab from "./ConvertTab";
import ConfigTab from "./ConfigTab";

const TAB_LIST = ["Upload", "Convert", "Config"];

export default function PlscaddKmzIngressTool() {
    const [selectedTab, setSelectedTab] = useState(0);

    return (
        <div style={{ paddingBottom: "200px" }}>
            <h1 style={{ textAlign: "center" }}>PLSCADD KMZ Ingress</h1>
            <Tabs
                value={selectedTab}
                onChange={(_event, newValue) => setSelectedTab(newValue)}
                indicatorColor="primary"
                textColor="primary"
                centered
            >
                {TAB_LIST.map((label, i) => (
                    <Tab key={i} label={label} />
                ))}
            </Tabs>
            {selectedTab === 0 && <UploadTab />}
            {selectedTab === 1 && <ConvertTab />}
            {selectedTab === 2 && <ConfigTab />}
        </div>
    );
}
